'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Minimize2 = function Minimize2(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ['color', 'size']);

  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 24 24',
      fill: 'none',
      stroke: color,
      strokeWidth: '2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }, otherProps),
    _react2.default.createElement('polyline', { points: '4 14 10 14 10 20' }),
    _react2.default.createElement('polyline', { points: '20 10 14 10 14 4' }),
    _react2.default.createElement('line', { x1: '14', y1: '10', x2: '21', y2: '3' }),
    _react2.default.createElement('line', { x1: '3', y1: '21', x2: '10', y2: '14' })
  );
};

Minimize2.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Minimize2.defaultProps = {
  color: 'currentColor',
  size: '24'
};

exports.default = Minimize2;


//////////////////
// WEBPACK FOOTER
// ./~/react-feather/dist/icons/minimize-2.js
// module id = 253
// module chunks = 46372528695858 69402227564285 95715928098905 99551900471989 114276838955818